import { ContentItem } from 'kentico-cloud-delivery';
import get from 'lodash/get';

export default class ThreeColumnGrid extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`,
    });
  }

  get columns() {
    return get(this, '_columns', []);
  }

  get htmlModifiers() {
    return get(this, '_html_modifiers', []);
  }
}



// WEBPACK FOOTER //
// ./src/models/ThreeColumnGrid.model.js